var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"form-link"},[_c('y-button',{on:{"click":function($event){$event.preventDefault();return _vm.element.handleClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }